import {evaluationTemplates, SPEAKING} from '@/common/courseTemplate.js'
import {evaluationTemplatesV3} from '@/common/courseTemplateV3.js'
import {evaluationTemplatesV1} from '@/core/option/evaluationTemplate'

export const V3_RUBRIC_KEYS = ['marking.basic.v3', 'marking.pre.v3', 'marking.foundation.v3']

export const isV3Rubric = (rubricKey) => V3_RUBRIC_KEYS.includes(rubricKey)

export const getEvaluationTemplate = (rubricKey, examType, index = 0, isSingleWriting = false) => {
  const isSpeaking = examType === SPEAKING

  switch (rubricKey) {
    case 'marking.basic':
      return isSpeaking ? evaluationTemplates.BasicSpeaking : evaluationTemplates.BasicWriting
    case 'marking.basic.v3':
      return isSpeaking ? evaluationTemplatesV3.BasicSpeaking : evaluationTemplatesV3.BasicWriting
    case 'marking.pre':
      return isSpeaking ? evaluationTemplates.PiSpeaking : evaluationTemplates.PiWriting
    case 'marking.pre.v3':
      return isSpeaking ? evaluationTemplatesV3.PiSpeaking : evaluationTemplatesV3.PiWriting
    case 'marking.foundation':
      return isSpeaking ? evaluationTemplates.FoundationSpeaking : evaluationTemplates.FoundationWriting
    case 'marking.foundation.v3':
      if (isSpeaking) return evaluationTemplatesV3.FoundationSpeaking
      return isSingleWriting || index === 1 ? evaluationTemplatesV3.FoundationWriting2 : evaluationTemplatesV3.FoundationWriting
    case 'marking.high.v1':
      return isSpeaking ? evaluationTemplatesV1.IEHighSpeaking : evaluationTemplatesV1.IEHighWriting
    case 'marking.high.v2':
      if (isSpeaking) return evaluationTemplates.IEHighSpeaking
      return isSingleWriting || index === 1 ? evaluationTemplates.IEHighWriting2 : evaluationTemplates.IEHighWriting
    default:
      return null
  }
}
